// «Show me where» for the App Store Connect team key: the Team Keys page with the tab (1), Issuer ID (2),
// Key ID column (3) and the + button (4). Shared by the Connections row and the instruction text (modal and
// /guide), like AppsflyerFigure. Positions are % of the 1280×556 image.
import { t } from "../i18n";
import { GuideFigure } from "./GuideFigure";

export function AscFigure({ testId }: { testId: string }) {
  return (
    <GuideFigure
      wide
      testId={testId}
      summary={t("conn.asc.figSummary")}
      src="/guides/app-store-connect-team-keys.png"
      alt={t("conn.asc.figAlt")}
      boxes={[
        { left: 20.8, top: 34.5, width: 6.4, height: 6.8 },
        { left: 20.8, top: 51.8, width: 20, height: 8.3 },
        { left: 45.8, top: 71.9, width: 7, height: 12.6 },
        { left: 27.5, top: 63.3, width: 2.3, height: 5.4 },
      ]}
      pins={[
        { n: 1, left: 20.8, top: 34.5 },
        { n: 2, left: 20.8, top: 51.8 },
        { n: 3, left: 45.8, top: 71.9 },
        { n: 4, left: 29.8, top: 63.3, shift: [-45, -55] },
      ]}
      caption={[
        <>
          <em>{t("conn.asc.fig1Em")}</em>
          {t("conn.asc.fig1")}
        </>,
        <>
          <em>{t("conn.asc.fig2Em")}</em>
          {t("conn.asc.fig2")}
        </>,
        <>
          <em>{t("conn.asc.fig3Em")}</em>
          {t("conn.asc.fig3")}
        </>,
        <>
          {t("conn.asc.fig4a")}
          <em>{t("conn.asc.fig4Em")}</em>
          {t("conn.asc.fig4b")}
        </>,
      ]}
    />
  );
}
